<template>
  <solution-sheet-item :title="$t('Vão')">
    <p class="solution_sheet__item__val" v-if="isSingleVal">
      {{ modelSpans.length }}x{{ modelSpans[0] }}m
    </p>

    <template class="solution_sheet__item__val" v-else>
      <p class="solution_sheet__item__val" v-if="cantileverSpans.length">
        C1: {{ cantileverSpans[0] }}m
      </p>
      <p
        class="solution_sheet__item__val"
        v-for="(mainSpan, i) in mainSpans"
        :key="i"
      >
        V{{ i + 1 }}: {{ mainSpan }}m
      </p>
      <p class="solution_sheet__item__val" v-if="cantileverSpans.length">
        C2: {{ cantileverSpans[1] }}m
      </p>
    </template>
  </solution-sheet-item>
</template>

<script>
import { withoutDuplicates } from "@/utils";
import { SolutionSheetItem } from "@/components";

export default {
  components: {
    SolutionSheetItem,
  },
  props: {
    modelSpans: {
      required: true,
      type: Array,
    },
    mainSpans: {
      required: true,
      type: Array,
    },
    cantileverSpans: {
      required: true,
      // type: Array,
      validator: (val) => Array.isArray(val) || val === null,
    },
  },

  computed: {
    isSingleVal() {
      return withoutDuplicates(this.modelSpans).length === 1;
    },
  },
};
</script>
